<script>
  export default {
    name: 'channel-new-modal',

    data () {
      return {
        channel: {}
      }
    },

    methods: {
      handleOk (e) {
        e.preventDefault()

        this.$store.dispatch('channels/addChannel', this.channel).then(() => {
          this.$refs.modal.hide()
          this.channel = {}
        }).catch((err) => {
          console.log('Unable to add channel', err)
        })
      }
    },

    created () {
      this.$emit('update:title', 'New Channel')
      this.$emit('update:ok-title', 'Save & Continue')
    }
  }
</script>

<template>
  <b-card-body>
    <b-form-group label="Channel Name">
      <b-input v-model="channel.name"/>
    </b-form-group>
  </b-card-body>
</template>
